import { Box, Button, Typography } from '@mui/material'
import { ReactNode } from 'react'
import { useNavAndFooterConstants } from '~hooks/use-nav-and-footer-constants'
import { COLORS } from '~theme/colors'

interface WarningRibbonProps {
  message: ReactNode
  buttonLabel: string
  onButtonClick: () => void
}

export function WarningRibbon({
  message,
  buttonLabel,
  onButtonClick,
}: WarningRibbonProps) {
  const { leftNavigationWidth } = useNavAndFooterConstants()

  return (
    <Box
      sx={{
        background: COLORS.orange.tint3,
        py: 3,
        px: { xs: 2, sm: 5 },
        display: 'flex',
        gap: 3,
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1201,
        ml: leftNavigationWidth,
      }}
    >
      <Typography component="span">{message}</Typography>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          onClick={onButtonClick}
          sx={{
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          {buttonLabel}
        </Button>
      </Box>
    </Box>
  )
}
